





























import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import MonthlyStatistics from '@/models/monthlystatistics';

export default class MonthlyStatisticsList extends Vue {
  header = ['Month', 'Total', 'Open', 'On Hold', 'Close'];

  @Prop() listData: MonthlyStatistics[] = [];

  @Watch('listData')
  logger() {}
}
